/**
 * @generated SignedSource<<d24a5ac0b2ec16e75740a9de8e0739ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebar_transaction$data = {
  readonly isNegotiable: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutAvalaraTaxExempt_transaction" | "CheckoutBuyerChargeCurrency_transaction" | "CheckoutDeposit_transaction" | "CheckoutSidebarItemInfo_transaction" | "CheckoutSidebarPromotion_transaction" | "CheckoutSidebarSidemarkPane_transaction" | "CheckoutTaxExemption_transaction" | "CheckoutTotals_transaction" | "CheckoutVatReverseCharge_transaction">;
  readonly " $fragmentType": "CheckoutSidebar_transaction";
};
export type CheckoutSidebar_transaction$key = {
  readonly " $data"?: CheckoutSidebar_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebar_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebar_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNegotiable",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarItemInfo_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTotals_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarPromotion_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeposit_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTaxExemption_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarSidemarkPane_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutVatReverseCharge_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBuyerChargeCurrency_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutAvalaraTaxExempt_transaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "b8802ca373af11fb3eaa78534c8c653b";

export default node;
